import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
// import axios from 'axios';
// import { PartnerSafeApi } from './EnvFiles';
// import { getStoredToken } from "../utils/getStoredToken";

const CreateContract = () => {
  // const [isLoading, setIsLoading] = useState(false);
  const [isLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [contractData, setContractData] = useState({
    numeroContrato: '',
    descricaoContrato: '',
    validadeContrato: '',
    cliente: ''
  });
  
  const [contractError, setContractError] = useState({
    numeroContrato: '',
    descricaoContrato: '',
    validadeContrato: '',
    cliente: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContractData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setContractError((prevError) => ({
      ...prevError,
      [name]: '',
    }));
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!contractData.numeroContrato) {
      isValid = false;
      errors.numeroContrato = 'Número do contrato é obrigatório';
    }

    if (!contractData.descricaoContrato) {
      isValid = false;
      errors.descricaoContrato = 'Descrição do contrato é obrigatória';
    }

    if (!contractData.validadeContrato) {
      isValid = false;
      errors.validadeContrato = 'Validade do contrato é obrigatória';
    }

    if (!contractData.cliente) {
      isValid = false;
      errors.cliente = 'Cliente é obrigatório';
    }

    setContractError(errors);

    return isValid;
  };

  const handleSubmit = async () => {
    // const token = getStoredToken();

    if (!validateForm()) {
      setSnackbarSeverity('error');
      setSnackbarMessage('Por favor, preencha todos os campos corretamente.');
      setSnackbarOpen(true);
      return;
    }

    console.log('DADOS DO CONTRATO QUE SERIAM ENVIADOS:', contractData);
    setSnackbarSeverity('success');
    setSnackbarMessage('Contrato cadastrado com sucesso!');
    setSnackbarOpen(true);

    // TODO: INTEGRAÇÃO COM A API AINDA NÃO FINALIZADA
    // setIsLoading(true);

    // try {
    //   const response = await axios.post(
    //     `${PartnerSafeApi}/api/v1/Contratos/Cadastrar`,
    //     contractData,
    //     { headers: { Authorization: `Bearer ${token}` } }
    //   );

    //   setSnackbarSeverity('success');
    //   setSnackbarMessage('Contrato cadastrado com sucesso!');
    //   setSnackbarOpen(true);
    // } catch (error) {
    //   setSnackbarSeverity('error');
    //   setSnackbarMessage('Erro ao cadastrar contrato!');
    //   setSnackbarOpen(true);
    //   console.error('Erro ao cadastrar contrato:', error);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        minHeight: '100vh',
        py: 2,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, color: '#40685E', mb: 3 }}>
        Cadastro de Contrato
      </Typography>

      {isLoading ? (
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
        }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <TextField
            label="Número do Contrato *"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            name="numeroContrato"
            value={contractData.numeroContrato}
            onChange={handleChange}
            error={!!contractError.numeroContrato}
            helperText={contractError.numeroContrato}
          />

          <TextField
            label="Descrição do Contrato *"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            name="descricaoContrato"
            value={contractData.descricaoContrato}
            onChange={handleChange}
            error={!!contractError.descricaoContrato}
            helperText={contractError.descricaoContrato}
          />

          <TextField
            label="Validade do Contrato *"
            variant="outlined"
            fullWidth
            type="date"
            sx={{ mb: 2 }}
            name="validadeContrato"
            value={contractData.validadeContrato}
            onChange={handleChange}
            error={!!contractError.validadeContrato}
            helperText={contractError.validadeContrato}
            slotProps={{
              inputLabel: { shrink: true },
            }}
          />

          <TextField
            label="Cliente *"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            name="cliente"
            value={contractData.cliente}
            onChange={handleChange}
            error={!!contractError.cliente}
            helperText={contractError.cliente}
          />

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Cadastrar Contrato
            </Button>
          </Box>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateContract;
